import { generateString, setPageAsFullHeight } from '@local_modules/flokit'
import { fillString } from '@local_modules/generic/string-template.js'
import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'
import { setElementHtml } from '../../../../helpers/generic-js/dom.js'

import htmlTemplateIndex from './index.html'
import { updateView } from './update-view.js'
import { activateActions } from './activate-actions.js'

/**
 *
 * @returns
 */
export async function showPageMonthlyValuesDataReview (params) {
  console.log('showPageMonthlyValuesDataReview')
  const { containerElementId, browserAppUser, browserAppEntity, accountingOrganisationId } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppUser })
  const elementId = 'i' + generateString()
  htmlIndex = fillString(htmlIndex, {
    elementId,
    accountingOrganisationId,
    entityName: browserAppEntity?.data?.appEntity?.name
  })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  setPageAsFullHeight(true, { containerSelector: '#app-content' })

  updateView(browserAppEntity)

  activateActions(document.getElementById(elementId))
}
